// Module
var code = `<div class="grid-box sidebar-box"><div class="smarter-message" translate="lessons.stream.student_dashboard_welcome_box.welcome_generic" translate-values="{brandName: brandNameShort, name: currentUser.preferredName}"></div></div>`;
// Exports
export default code;